var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',{staticClass:"d-flex justify-space-between mb-6"},_vm._l((_vm.users),function(i){return _c('user-card',{key:i.id,staticClass:"pa-2",attrs:{"user":i}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }